// extracted by mini-css-extract-plugin
export var searchHeader = "_9t-0";
export var searchHeaderDark = "_9t-1";